import React from "react";
import { IconButton, TableCell } from "@material-ui/core";

const wrapperStyle = {
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  gap: 4,
  whiteSpace: "nowrap",
};

const countStyle = {
  fontSize: 12,
};

export default function ActionCountCell({
  label,
  icon: IconComponent,
  onClick,
  count = 0,
  disabled = false,
  hideZeroCount = false,
}) {
  const shouldShowCount = !hideZeroCount || count > 0;

  return (
    <TableCell align="center">
      <div style={wrapperStyle}>
        <IconButton
          aria-label={label}
          onClick={onClick}
          disabled={disabled}
          size="small"
        >
          <IconComponent fontSize="small" />
        </IconButton>

        {shouldShowCount && <span style={countStyle}>({count})</span>}
      </div>
    </TableCell>
  );
}
